// TODO: rename FamilyAndDwellingCondition
import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

module.exports = {
  // "Family Composition": ({data, geo, geo_aggregation}) => <div>Table</div>
}



// WEBPACK FOOTER //
// ./components/Tables/Households.js